<div>
    <img [src]="imageUpload$" />
</div>